import PropTypes from "prop-types";
import React, { useState } from "react";

const Checkbox = ({
  id,
  label,
  links = [], // Default parameter
  checked,
  onChange,
  required = false, // Default parameter
  disabled=false,
  className=""
}) => {
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const isChecked = e.target.checked;
    setError(required && !isChecked ? "Ce champ est obligatoire." : "");
    onChange(e);
  };

  return (
    <>
    
    <div className="custom-checkbox">
    <label htmlFor={id} className={`checkbox-label d-flex align-items-center ${className}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
      /> 
      <span className={`checkbox-box ${checked ? "checked" : ""}`}>
          {checked && (
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2008 6.09961L6.42777 10.8996L4.80078 9.26342"
                stroke="#2D71E2"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>
     
        <span className="w-fit-content">
  {label}{" "}
  {links.map((link, index) => (
    <React.Fragment key={index}>
      {link.url ? (
        <a href={link.url} className="checkbox-link">
          {link.text}
        </a>
      ) : (
        <span>{link.text}</span> // Ensures text is correctly handled
      )}
      {/* Add " et " only if the next element has a URL (avoid duplicate "et") */}
    
    </React.Fragment>
  ))}
</span>

      </label>
      
    </div>
    {error && <small className="error-message">{error}</small>}</>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string,
    })
  ),
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

export default Checkbox;